import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Box } from '@mui/material';
import styles from './ResultTableFilters.module.scss';
import { useTranslation } from 'react-i18next';
export function ICCheckbox({ isChecked, handleToggle }) {
    const { t } = useTranslation();
    return (_jsxs(Box, { className: styles.icBoxContainer, display: 'flex', gap: '10px', alignItems: 'center', children: [_jsx(Checkbox, { checked: isChecked, onChange: () => handleToggle(!isChecked) }), t('Show only IC')] }));
}
